import { createBrowserHistory, createMemoryHistory } from 'history'
import { isServer } from 'config/helpers'

export default isServer
  ? createMemoryHistory()
  : createBrowserHistory()
